import React,{useContext} from 'react';
import {MovieContext} from './MovieContext';
import Movie from './Movie';
import Header from './ui/Header'
import Spinner from './ui/Spinner'
import Pagination from './ui/Pagination'
import SmallWatchList from './SmallWatchList'
import Footer from './ui/Footer'


const MovieList = () => {

const {isLoading} = useContext(MovieContext)

    const {movies,setQuery,totalResults,nextPage,currentPage} = useContext(MovieContext);

    let numberPages = Math.floor(totalResults / 20)
    // if (totalResults > 500) {
    //   numberPages = 26;
    // }


    return (
        <div>
            
        <Header getQuery={(query) => setQuery(query)}/>
        <SmallWatchList></SmallWatchList>
        {isLoading ? <Spinner/> : <div className='container movielist'>
           {movies.map(movie => (
              <Movie movie = {movie} key = {movie.id}></Movie>
            ))}
         {totalResults > 20 ? <Pagination pages={numberPages} nextPage={nextPage} currentPage={currentPage}/>: ''}
       </div>}
         {/* <div className='greybar'></div>   */}
        
         {totalResults ? <Footer></Footer> : null}
        </div>
    );
}

export default MovieList;
